/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Err_Rate_LimitedInputs */

const en_rd_err_rate_limited = /** @type {(inputs: Rd_Err_Rate_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too many checks right now. Try again in a few minutes.`)
};

const id_rd_err_rate_limited = /** @type {(inputs: Rd_Err_Rate_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terlalu banyak pengecekan. Coba lagi beberapa menit lagi.`)
};

/**
* | output |
* | --- |
* | "Too many checks right now. Try again in a few minutes." |
*
* @param {Rd_Err_Rate_LimitedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_err_rate_limited = /** @type {((inputs?: Rd_Err_Rate_LimitedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Err_Rate_LimitedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_err_rate_limited(inputs)
	return en_rd_err_rate_limited(inputs)
});